// extracted by mini-css-extract-plugin
export default {"step-item":"StepItem_step-item__5K5Lt","step-number":"StepItem_step-number__1s8yO","step-content":"StepItem_step-content__yNSoY"};